import React from 'react';
import { TFunction } from 'i18next';
import { ConflictWithCampaignsErrorDto } from '@shared/services/apiService/missing-types';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { toast } from 'react-toastify';
import { CustomErrorToast } from '@shared/components/customErrorToast';

export const renderProfileInUseMessage = (
  errorData: ConflictWithCampaignsErrorDto,
  t: TFunction,
): React.ReactNode => {
  const campaignNames = (errorData.metadata.campaigns || [])
    .map((campaign) => campaign.name || campaign.title)
    .filter(Boolean)
    .join(', ');

  return (
    <>
      {errorData.message}
      {campaignNames ? (
        <>
          <br />
          <br />
          {t('assistantsPage.errors.campaignsUsingProfile', { campaignNames })}
        </>
      ) : null}
    </>
  );
};

export const showProfileConflictToast = (
  error: unknown,
  t: TFunction,
  title: string,
  suggestion: string,
): boolean => {
  const fetchError = error as FetchBaseQueryError;
  if (
    typeof fetchError?.status === 'number' &&
    fetchError.status === 409 &&
    fetchError.data &&
    typeof fetchError.data === 'object' &&
    'metadata' in fetchError.data &&
    'message' in fetchError.data
  ) {
    const typedError = fetchError.data as ConflictWithCampaignsErrorDto;
    toast.error(
      (props) => (
        <CustomErrorToast
          {...props}
          title={title}
          message={renderProfileInUseMessage(typedError, t)}
          suggestion={suggestion}
        />
      ),
      {
        closeButton: false,
        autoClose: 8000,
        icon: false,
      },
    );
    return true;
  }

  return false;
};
